import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { FaEye, FaEyeSlash, FaUser } from 'react-icons/fa';

const ReusableInput = ({ 
    label, 
    value, 
    onChange, 
    placeholder, 
    error, 
    icon, 
    name, 
    required,
    type = "text" 
}) => {
    const [showPassword, setShowPassword] = useState(false);
    
    const isPasswordField = type === "password";
    const inputType = isPasswordField ? (showPassword ? "text" : "password") : type;

    return (
        <Form.Group className="mb-4">
            <div className="input-wrapper" style={{ position: 'relative' }}>
                <Form.Control
                    className="reusable-input"
                    type={inputType}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder || label}
                    name={name}
                    style={{
                        width: '100%',
                        padding: '16px 50px 16px 16px',
                        border: 'none',
                        borderRadius: '50px',
                        backgroundColor: '#F5F5F7',
                        fontSize: '16px',
                        color: '#1D1D1F',
                        outline: 'none',
                        boxShadow: 'none'
                    }}
                />
                
                {/* Icon on the RIGHT */}
                <div 
                    style={{
                        position: 'absolute',
                        right: '16px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: '#9CA3AF',
                        zIndex: 1
                    }}
                >
                    {isPasswordField ? (
                        <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                color: '#9CA3AF',
                                padding: 0,
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
                        </button>
                    ) : (
                        icon || <FaUser size={20} />
                    )}
                </div>
            </div>
            
            {error && (
                <span style={{
                    fontSize: "0.875rem",
                    color: "#FF3B30",
                    marginTop: "4px",
                    display: "block"
                }}>
                    {error}
                </span>
            )}
        </Form.Group>
    );
};

ReusableInput.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    error: PropTypes.string,
    icon: PropTypes.element,
    name: PropTypes.string.isRequired,
    required: PropTypes.bool,
    type: PropTypes.string
};

ReusableInput.defaultProps = {
    placeholder: '',
    error: '',
    icon: null,
    required: false,
    type: 'text'
};

export default ReusableInput;